import {makeAutoObservable} from "mobx";

export default class EventOccurrenceInformation {
  occurrenceDate: Date;
  totalBookings: number | null;
  totalPaidBookings: number | null;

  constructor(
    occurrenceDate: Date,
    totalBookings: number | null,
    totalPaidBookings: number | null
  ) {
    makeAutoObservable(this);
    this.occurrenceDate = occurrenceDate;
    this.totalBookings = totalBookings;
    this.totalPaidBookings = totalPaidBookings;
  }
}
